import axios, { AxiosInstance, AxiosRequestConfig } from 'axios';
import type { Cancelable, Response } from '../types';
import { Client, ContentType } from '../client';
import prepareRequestData from '../utils';

export default class AxiosClient implements Client {
  httpClient: AxiosInstance;

  constructor(baseURL = '') {
    this.httpClient = axios.create();
    this.httpClient.defaults.baseURL = baseURL;
  }

  async get<T>(path: string, data?: AxiosRequestConfig): Promise<Response<T>> {
    const { httpClient } = this;
    return httpClient.get(path, data);
  }

  async post<T>(
    path: string,
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any = {},
    contentType: ContentType = ContentType.FORM_URLENCODED,
    options: AxiosRequestConfig = {},
    cancelRequest?: (abortController: AbortController) => void
  ): Promise<Response<T> & Cancelable> {
    const { httpClient } = this;

    const controller = new AbortController();
    cancelRequest?.(controller);

    const config = {
      headers: {
        'Content-Type': contentType,
      },
      signal: controller.signal,
      ...options,
    };

    const requestData = prepareRequestData(data, contentType);
    return httpClient.post(path, requestData, config);
  }

  async patch<T>(path: string, data: URLSearchParams): Promise<Response<T>> {
    const { httpClient } = this;
    const config = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    };
    return httpClient.patch(path, data.toString(), config);
  }

  async delete<T>(path: string): Promise<Response<T>> {
    const { httpClient } = this;
    return httpClient.delete(path);
  }
}
